//Internal site routes
export const ROOT = '/';
export const LOGIN = '/login';
export const RESETPASS = '/reset-password';
export const SIGNUP = '/sign-up';
export const AUTHROOT = '/member-home';
export const LTVLIBHOME = '/library';
export const LTVLIBCATEGORY = '/library/category/:id/:name';
export const LTVLIBNEWANDFEATURED = '/library/new-and-featured';
export const LTVLIBLINKTIVITY =
  '/library/linktivity/:category/:categoryId/:id/:name';
export const PROFILE = '/profile';
export const SUBSCRIPTION = '/subscription';
export const BILLING = '/billing';
export const REFER = '/refer';

//External URLs
export const EXT_TUTORIALS =
  'https://www.linktivitylearning.com/member-video-tutorials';
export const EXT_TOS =
  'https://classroomnook-public.s3.us-east-2.amazonaws.com/documents/Terms-of-Service.pdf';
export const EXT_PRIVACYPOLICY =
  'https://classroomnook-public.s3.us-east-2.amazonaws.com/documents/Privacy-Policy.pdf';
export const EXT_WHATISLINKTIVITY =
  'https://www.linktivitylearning.com/what-is-a-linktivity';
export const EXT_FAQS = 'https://www.linktivitylearning.com/faq';
export const EXT_CONTACT = 'https://www.linktivitylearning.com/contact';
export const EXT_DISTRICTPLANS =
  'https://www.linktivitylearning.com/schools-districts';
export const EXT_REF_TOS =
  'https://classroomnook-public.s3.us-east-2.amazonaws.com/documents/Referral-Program-Terms.pdf';
